var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._l((_vm.components),function(component,index){return _c('div',{key:index,staticClass:"container__content"},[_c('render-content',{attrs:{"content":[component]}})],1)}),_vm._v(" "),_c('RichText',{staticClass:"container__note",attrs:{"text":_vm.note}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }